import { Outlet, useNavigate, useParams, Navigate } from 'react-router';

import { useEffect } from 'react';

import { useUserData } from '@app-velocity/libs/auth';

import { Loader } from '@app-velocity/animations';
import {
  useCurrentTeam,
  useCurrentTeamStore,
  usePaidTeamAvailableNotification,
} from '@app-velocity/modules/teams';
import {
  useGetTeamsQuery,
  useProjectsQuery,
} from '@app-velocity/libs/teams-data-access';

export const WorkspaceProtectedRoute = () => {
  const { userId } = useUserData();
  const { data: workspaces, isLoading: areWorkspacesLoading } =
    useProjectsQuery(userId);

  const {
    data: teams,
    isLoading: areTeamsLoading,
    isFetching: areTeamsFetching,
  } = useGetTeamsQuery();
  const { workspaceId: workspaceIdParam, teamId: teamIdParam } = useParams();
  const {
    setCurrentTeamId,
    setCurrentWorkspaceId,
    teamId: currentTeamId,
  } = useCurrentTeamStore();
  const { activeTeam, activeWorkspace } = useCurrentTeam(
    userId,
    workspaceIdParam,
    teamIdParam
  );

  usePaidTeamAvailableNotification(activeTeam, teams || [], teamIdParam);

  const navigate = useNavigate();

  useEffect(() => {
    if (!workspaceIdParam || !teamIdParam) return;

    setCurrentWorkspaceId(workspaceIdParam);
    setCurrentTeamId(teamIdParam);
  }, [teamIdParam, workspaceIdParam, setCurrentWorkspaceId, setCurrentTeamId]);

  // Redirecting after workspaces changed
  useEffect(() => {
    if (!workspaces || !teams || workspaceIdParam || areTeamsFetching) return;

    const team = teamIdParam
      ? teams.find((t) => t.teamId === teamIdParam) || teams[0]
      : teams.find((t) => t.teamId === currentTeamId) || teams[0];

    const firstWorkspaceInTeam = workspaces.find(
      (w) => w.teamId === team.teamId
    );

    if (!firstWorkspaceInTeam) return;

    navigate(`/${team.teamId!}/${firstWorkspaceInTeam.id}`);
  }, [
    workspaces,
    teams,
    workspaceIdParam,
    teamIdParam,
    currentTeamId,
    areTeamsFetching,
  ]);

  if (
    areWorkspacesLoading ||
    areTeamsLoading ||
    !teamIdParam ||
    !workspaceIdParam
  )
    return <Loader />;

  if (
    activeTeam &&
    activeWorkspace &&
    teamIdParam &&
    workspaceIdParam &&
    (activeTeam.teamId !== teamIdParam ||
      activeWorkspace.id !== workspaceIdParam)
  )
    return <Navigate to="/" />;

  return <Outlet />;
};
